import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";


export default function Meeting({ ...rest }) {
  
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
   
    window.location.href='https://1drv.ms/x/s!Al6qkcqJXp87xSIvCZi4JXzAliQx?e=vI8Axe';

  }, []);
  return (
    <div>
    </div>
  );
}
